import { InstructionsInfoBox } from "newui/components/ui/InstructionsInfoBox/InstructionsInfoBox";
import { panelMeetingSteps } from "guides/features/Evaluation";

const DEFAULT_INSTRUCTIONS = [
  "Review each criterion by comparing panel member scores.",
  "Discuss any disparities and reach a consensus score for each supplier (entered at the bottom), before moving to the next criterion.",
  "You can click the 'Scoring Guide' button in the top-right to show the scoring guide.",
  "Use the navigation above to move between criteria.",
  "Consensus scores and panel notes will be saved automatically as you go.",
  "You can hover over any score to highlight what you are discussing and use the speech bubble to show any comments entered by panel members for that score.",
  "When you are done, click 'Complete Meeting' to finalise the scores and move to the award decision step.",
];

export const InstructionsBox: React.FC = () => {
  return (
    <div className="mx-4 my-3">
      <InstructionsInfoBox
        title="Meeting Instructions"
        collapsible
        data-testid="meeting-instructions-box"
        instructions={DEFAULT_INSTRUCTIONS}
        guideSteps={panelMeetingSteps}
        showGuideLabel="Show Me Around"
      />
    </div>
  );
};
